var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinanceLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.52722 8.41049L0.188446 10.6987L1.76438 7.822L4.85482 3.70412L6.78051 3.01172L2.52722 8.41049Z",
    fill: "#31B60E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5197 12.3033L0 14.7799L1.72849 11.7498L8.81724 2.27951L11.0175 1.48828L2.5197 12.3033Z",
    fill: "#31B60E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.48493 13.6787L0.93985 17.4409L3.64354 13.0909L12.8484 0.830657L15.1987 0L4.48493 13.6787Z",
    fill: "#31B60E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2133 3.83426L6.42658 15.0375L2.84113 18.8536L5.5849 14.449L15.2133 1.62305V3.83426Z",
    fill: "#31B60E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2133 7.61446L8.34387 16.3783L5.70071 19.0166L7.54873 15.8222L15.2133 5.57422V7.61446Z",
    fill: "#31B60E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2132 11.3722L12.0278 15.4223L9.66699 17.7266L11.257 14.8533L15.2132 9.57031V11.3722Z",
    fill: "#31B60E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinanceLogo);
export default __webpack_public_path__ + "static/media/financeLogo.799fd8c95e0bc0d727a24e8b614157bf.svg";
export { ForwardRef as ReactComponent };